import { minPasswordLength, passwordMinCharsPerClass, passwordMinClasses } from '@gonfalon/constants/constants';
import { enableRemoveOrganizationFromSignup } from '@gonfalon/dogfood-flags/dogfood-flags';
// eslint-disable-next-line no-restricted-imports
import { fromJS, Record } from '@gonfalon/immutable-shim/immutableShim';
import {
  checkPasswordCharacters,
  isEmail,
  isLength,
  isNotEmpty,
  validateRecord,
} from '@gonfalon/legacy-form-validation/validationUtils';
import type { CreateFunctionInput, ImmutableMap } from '@gonfalon/legacy-immutable/immutableUtils';

import { PROFILE_NAME_MAX_LENGTH } from '#utils/accounts/accountTypes';

export type SignUpFormType = {
  firstName: string;
  lastName: string;
  organization: string;
  username: string;
  password: string;
  captcha: string;
  oauth: ImmutableMap<{
    userId: string;
    provider: string;
  }> | null;
  jobRole?: string;
  acceptTerms?: boolean;
  marketingEmails?: boolean;
  bypassSsoDomainSafeguard?: boolean;
};

export class SignupForm extends Record<SignUpFormType>({
  firstName: '',
  lastName: '',
  organization: '',
  username: '',
  password: '',
  captcha: '',
  oauth: null,
  acceptTerms: false,
  marketingEmails: false,
  bypassSsoDomainSafeguard: false,
}) {
  validate() {
    let predicates = [
      isNotEmpty('username'),
      isEmail('username'),
      isNotEmpty('firstName'),
      isLength(0, PROFILE_NAME_MAX_LENGTH)('firstName'),
      isNotEmpty('lastName'),
      isLength(0, PROFILE_NAME_MAX_LENGTH)('lastName'),
    ];

    if (!enableRemoveOrganizationFromSignup()) {
      predicates = predicates.concat(isNotEmpty('organization'));
    }

    if (this.oauth !== null) {
      predicates = predicates.concat(isNotEmpty('userId'), isNotEmpty('oauth.provider'), isNotEmpty('oauth.userId'));
    } else {
      predicates = predicates.concat(
        isNotEmpty('password'),
        isLength(minPasswordLength())('password'),
        checkPasswordCharacters({
          requiredCharCountPerClass: passwordMinCharsPerClass(),
          requiredClassCount: passwordMinClasses(),
        })('password'),
      );
    }

    return validateRecord(this, ...predicates);
  }
}

export function createSignupForm(props: CreateFunctionInput<SignupForm> = {}) {
  return props instanceof SignupForm ? props : new SignupForm(fromJS(props));
}
